import { HttpClient } from '@angular/common/http';
import { Component, ElementRef, EventEmitter, HostListener, Input, OnInit, Output, ViewChild } from '@angular/core';
import { AppComponent } from 'src/app/app.component';
import { GenericModalSettings } from 'src/app/models/generic-modal-settings';
import { UiService } from 'src/app/services/ui.service';
import { DpadSelectableDirective } from '../../lib/proto-dpad-navigation/directives/dpad-selectable.directive';

@Component({
	selector: 'generic-modal',
	templateUrl: './generic-modal.component.html',
	styleUrls: ['./generic-modal.component.scss']
})
export class GenericModalComponent implements OnInit {

	@Input() logoPath!: string;
	title: string | undefined = "Title";
	text: string | undefined = "Text";
	showCloseButton: boolean = false;
	closeLabel: string = "CLOSE";
	isClosing: boolean = false;

	elementFocusCallback: () => void;

	okCallback!: () => void;
	okLabel: string = 'OK';

    @ViewChild('closeButton') closeButton: ElementRef;
    @ViewChild('okButton') okButton: ElementRef;

	@Output() closeModal = new EventEmitter<void>();

	constructor(private http: HttpClient,
		private ui: UiService) { }

	async ngOnInit(): Promise<void> {
		let settings: GenericModalSettings = this.ui.getGenericModalSettings();
		this.title = settings.title ?? this.title;
		this.text = settings.body ?? this.text;
		this.okLabel = settings.okLabel;
		this.okCallback = settings.okCallback;
		this.showCloseButton = settings.close ?? this.showCloseButton;
		this.closeLabel = settings.closeLabel ?? this.closeLabel;
		this.elementFocusCallback = settings.elementFocusCallback;
		this.okLabel = settings.okLabel;
		this.okCallback = settings.okCallback;
	}

	close() {
		if (this.isClosing) {
			return;
		}
		this.isClosing = true;
		setTimeout(() => {
			this.ui.stopShowingGenericModal();
		}, 200)
	}

	ngOnDestroy() {
		if (this.elementFocusCallback) {
			this.elementFocusCallback();
		}
		this.ui.clearGenericModalSettings();
	}

	@HostListener('keydown', ['$event'])
	onKeyDown(event: any) {
	
		if (event.key == 'ArrowLeft') {
			if (!this.okCallback || document.activeElement == this.okButton.nativeElement) {
				event.preventDefault();
				event.stopPropagation();
			}
		} else if (event.key == 'ArrowRight') {
			if (!this.okCallback || document.activeElement == this.closeButton.nativeElement) {
				event.preventDefault();
				event.stopPropagation();
			}
		} else if (event.key == 'ArrowUp') {
			event.preventDefault();
			event.stopPropagation();
		} else if (event.key == 'ArrowDown') {
			event.preventDefault();
			event.stopPropagation();
		}
	
		if (event.key === 'Unidentified' && event.keyCode == 27) {
			event.preventDefault();
			event.stopPropagation();
			this.close();
		}
	}

	ok() {
		this.okCallback();
		this.ui.stopShowingGenericModal();
	}

	refocus() {
		if (!this.okLabel) {
			this.closeButton.nativeElement.focus();
		}
	}
}
